export default {
	path: "/contract",
	component:() => import('@/module/contractModule/viewPage/index.vue'),
	meta:{title:"合同"},
}